@if (showTitle(titleText, documents)) {
  <h2
    data-cy="title"
    class="d-flex align-items-center navigation__medium--l"
  >{{titleText | cxTranslate}}</h2>
}

<div [class.separator]="showSeparator" class="d-none d-sm-block udex-my-20"></div>
@if (cartIsLoading) {
  @if (showTitle(titleText, documents)) {
    <div class="skeleton-height col-12 row">
      <dcp-content-loading-indicator></dcp-content-loading-indicator>
    </div>
  }
} @else {
  @if (firstName || lastName) {
    <div class="text-grey body--s" data-cy="name">
      {{firstName}} {{lastName}}
    </div>
  }
  @if (!!email) {
    <div class="text-grey body--s text-break" data-cy="email">{{email}}</div>
  }
  @if (!!companyName) {
    <div class="text-grey body--s" data-cy="company-name">{{companyName}}</div>
  }
  @if (!!industry) {
    <div class="text-grey body--s" data-cy="industry">{{industry}}</div>
  }
  @if (!!formattedAddress) {
    <div class="text-grey body--s" data-cy="formatted-address">{{formattedAddress}}</div>
  }
  @if (!!country) {
    <div class="text-grey body--s" data-cy="country">{{country.isocode}}</div>
  }
  @if (!!paymentName) {
    <div class="d-flex align-items-center udex-mt-12">
      <img
        [src]="paymentName === 'Card' ? '../../assets/images/checkout/review/card.svg' : '../../assets/images/checkout/review/invoice.svg'"
        class="udex-me-12" [alt]="'cart.paymentMethod' | cxTranslate">
      <span data-cy="payment-name"
            class="navigation__medium--l text-grey">{{paymentName === 'Card' ? ('cart.creditCard' | cxTranslate) : paymentName}}</span>

    </div>
  }
  @if (!!documents) {
    <div data-cy="documents">
      @for (doc of documents; track $index) {
        <udex-link
          class="d-block udex-pb-8"
          design="Default"
          [href]="generatePath(doc.downloadUrl)"
          target="_blank"
        >
          <span class="body--s">{{transformName(doc.downloadUrl)}}</span>
        </udex-link>
      }
    </div>
  }
}

